<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-card elevation="4">
                                <v-card-text>
                                    <v-row dense>
                                        <v-row align="center" no-gutters>
                                            <span class="text-h6">Workload Status</span>
                                            <v-spacer></v-spacer>
                                            <div>
                                                <v-btn
                                                    v-if="workLoadData.pre_approved_status != null"
                                                    @click="checkPDFAssignatories()"
                                                    :disabled="loading"
                                                    text="Print Pre-Approved Faculty Workload"
                                                    variant="elevated"
                                                    elevation="3"
                                                    color="darkGreen"
                                                ></v-btn>
                                            </div>
                                        </v-row>
                                    </v-row>
                                </v-card-text>
                                <v-card-text>
                                    <v-divider class="mt-n3 mb-3"></v-divider>
                                    <v-row>
                                        <v-col v-if="workLoadData.preparer_ids.length == 0" cols="12">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <v-chip color="darkGreen">For Preparation</v-chip>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.preparer_ids.length > 0" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Prepared By:</div>
                                                    <div v-for="preparer in workloadDetails.preparers" :key="preparer">
                                                        <div class="mt-4">{{ getItemTitle(preparer) }}</div>
                                                        <div class="text-caption font-weight-bold">{{ preparer?.designation }}</div>
                                                    </div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.prepared_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.recommender_approval_ids.length > 0" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Recommending Approval By:</div>
                                                    <div v-for="recommender in workloadDetails.recommenders" :key="recommender">
                                                        <div class="mt-4">{{ getItemTitle(recommender) }}</div>
                                                        <div class="text-caption font-weight-bold">{{ recommender?.designation }}</div>
                                                    </div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.recommending_approval_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.pre_approved_status != null" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Pre Approved By:</div>
                                                    <div class="mt-4">{{ getItemTitle(workloadDetails.pre_approver) }}</div>
                                                    <div class="text-caption font-weight-bold">{{ workloadDetails.pre_approver?.designation }}</div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.pre_approved_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                        <v-col v-if="workLoadData.approved_status != null" cols="12" md="3">
                                            <v-card elevation="3">
                                                <v-card-text>
                                                    <div class="font-weight-bold">Approved By:</div>
                                                    <div class="mt-4">{{ getItemTitle(workloadDetails.approver) }}</div>
                                                    <div class="text-caption font-weight-bold">{{ workloadDetails.approver?.designation }}</div>
                                                    <div class="mt-4 text-caption">{{ formatDate(workLoadData.approved_date) }}</div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card elevation="3">
                                <v-card-text>
                                    <v-row dense class="mt-lg-8">
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label color="black">Faculty:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="8">
                                                    <v-text-field
                                                        v-model="faculty_name"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Employment Status:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="7">
                                                    <v-text-field
                                                        v-model="employment_status"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Designation:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="8">
                                                    <v-text-field
                                                        v-model="designation"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Rank:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="8">
                                                    <v-text-field
                                                        v-model="rank"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Institute:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="8">
                                                    <v-text-field
                                                        v-model="institute"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Department:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="8">
                                                    <v-text-field
                                                        v-model="department"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-lg-8">
                                        <v-col cols="12" md="6">
                                            <v-row dense align="center">
                                                <v-col cols="12" class="text-lg-left ml-lg-12">
                                                    <v-label>Educational Preparation:</v-label>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="3" class="text-lg-right">
                                                            <v-label>Bachelor's Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="9">
                                                            <v-text-field
                                                                v-model="undergraduate"
                                                                readonly
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col v-if="graduate" cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="3" class="text-lg-right">
                                                            <v-label>Master's Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="9">
                                                            <v-text-field
                                                                v-model="graduate"
                                                                readonly
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col v-if="post_graduate" cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="3" class="text-lg-right">
                                                            <v-label>Doctoral/Professional Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="9">
                                                            <v-text-field
                                                                v-model="post_graduate"
                                                                readonly
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-lg-8">
                                        <v-col cols="12" md="6">
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <v-row align="center" class="ml-lg-8 d-flex">
                                                        <v-col cols="3" class="text-lg-right">
                                                            <v-checkbox @update:model-value="toggleTeachApplicable" v-model="is_team_teach" label="Team Teach Applicable?"></v-checkbox>
                                                        </v-col>
                                                        <v-col v-if="team_teach_name && $store.state.user.program.abbrev == department" cols="4" class="text-lg-right">
                                                            <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="changeTeamTeach()">Change Team Teach</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="is_team_teach" dense align="center">
                                                <v-col cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="3" class="text-lg-right">
                                                            <v-label>Team Teaching:</v-label>
                                                        </v-col>
                                                        <v-col v-if="!team_teach_name" cols="12" md="9">
                                                            <v-autocomplete
                                                                v-model="teamTeachData"
                                                                @update:model-value="teamTeachEducation"
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                                :items="facultyDataForTeamTeach"
                                                                :item-title="getItemTitle"
                                                                item-value="id"
                                                                return-object
                                                            ></v-autocomplete>
                                                        </v-col>
                                                        <v-col v-else cols="12" md="9">
                                                            <v-text-field
                                                                v-model="team_teach_name"
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="4" class="text-lg-right">
                                                            <v-label>Bachelor's Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="8">
                                                            <v-text-field
                                                                v-model="team_teach_undergraduate"
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="4" class="text-lg-right">
                                                            <v-label>Master's Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="8">
                                                            <v-text-field
                                                                v-model="team_teach_graduate"
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col v-if="team_teach_post_graduate" cols="12">
                                                    <v-row align="center">
                                                        <v-col cols="12" md="4" class="text-lg-right">
                                                            <v-label>Doctoral/Professional Degree:</v-label>
                                                        </v-col>
                                                        <v-col cols="12" md="8">
                                                            <v-text-field
                                                                v-model="team_teach_post_graduate"
                                                                color="darkGreen"
                                                                variant="underlined"
                                                                density="comfortable"
                                                                class="font-weight-bold"
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Core Time:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="core_time"
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="3" class="text-lg-right">
                                                    <v-label>Consultation Time:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="consultation_time"
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                            <v-col cols="12">
                                                <v-btn
                                                :disabled="workLoadData.approved_status == 'approved'"
                                                @click="showAddFacultyLoadDialog()"
                                                prepend-icon="mdi-plus"
                                                class="mt-1 rounded-lg"
                                                color="routesColor"
                                                height="40px"
                                                elevation="2">
                                                    Add Course Load
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="12">
                                            <v-card class="dt-container">    
                                                <v-data-table
                                                    :mobile="isMobileOrTablet()"
                                                    :headers="headers"
                                                    :items="courseLoadData"
                                                    :loading="loading"
                                                    hide-default-footer
                                                    class="text-caption"
                                                    :items-per-page="50"
                                                >
                                                <template v-slot:loading>
                                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                </template>
                                                <template v-slot:item.title="{ item }">
                                                    <div class="text-truncate" style="max-width: 150px;">
                                                        {{ item.title }}
                                                    </div>
                                                </template>
                                                <template v-slot:item.datecreated="{ item }">
                                                    <span>{{ formatDateTime(item.datecreated)}} </span>
                                                </template>
                                                <template v-slot:[`item.action`]="{ item }">
                                                    <div class="d-flex flex-column justify-end ga-2 py-2">
                                                        <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="showFacultyLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                        <!-- <v-btn  @click="showDeleteCourseDialog(item)" size="x-small" variant="outlined" text="Delete" color="red" elevation="3"></v-btn> -->
                                                    </div>
                                                </template>
                                                </v-data-table>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total Teaching Hours/Wk:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="total_teaching_hours"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total No. of Preparation:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="total_preparation"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="ms_load_eqv != 0" dense>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total MS Load Equivalent :</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="ms_load_eqv"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total  No. of MS Student:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="ms_total_student"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="ge_load_eqv != 0" dense>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total GE Load Equivalent:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="ge_load_eqv"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total  No. of GE Student:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="ge_total_student"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="profed_load_eqv != 0" dense>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total ProfEd Load Equivalent :</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="profed_load_eqv"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total  No. of ProfEd Student:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="profed_total_student"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="gs_load_eqv != 0" dense>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total GS Load Equivalent :</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="gs_load_eqv"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row align="center">
                                                <v-col cols="12" md="4" class="text-lg-right">
                                                    <v-label>Total  No. of GS Student:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        v-model="gs_total_student"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-row dense align="center">
                                                <v-col cols="12" md="6">
                                                    <span class="font-weight-bold text-h6">ADMIN Load Release</span>
                                                </v-col>
                                                <v-col class="text-right" cols="12" md="6">
                                                    <v-btn
                                                    :disabled="workLoadData.approved_status == 'approved'"
                                                    @click="showAddAdminDialog(user)"
                                                    prepend-icon="mdi-plus"
                                                    class="mt-1 rounded-lg"
                                                    color="routesColor"
                                                    height="40px"
                                                    elevation="2">
                                                        Add Admin Load
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="12" class="mt-1">
                                                    <v-card class="dt-container">    
                                                        <v-data-table
                                                            :mobile="isMobileOrTablet()"
                                                            :headers="loadHeaders"
                                                            :items="adminLoadData"
                                                            :loading="loading"
                                                            hide-default-footer
                                                            class="text-body-2"
                                                        >
                                                        <template v-slot:loading>
                                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                        </template>
                                                        <template v-slot:item.description="{ item }">
                                                            <div class="text-truncate" style="max-width: 600px;">
                                                                {{ item.description }}
                                                            </div>
                                                        </template>
                                                        <template v-slot:item.to_be_counted="{ item }">
                                                            <v-icon v-if="item.to_be_counted == true" color="green">mdi-check</v-icon>
                                                            <v-icon v-else color="red">mdi-close</v-icon>
                                                        </template>
                                                        <template v-slot:item.datecreated="{ item }">
                                                            <span>{{ formatDateTime(item.datecreated)}} </span>
                                                        </template>
                                                        <template v-slot:[`item.action`]="{ item }">
                                                            <div class="d-flex justify-end ga-2">
                                                                <v-btn :disabled="workLoadData.approved_status == 'approved'" @click="showEditAdminLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                            </div>
                                                        </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-col>   
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-row dense align="center">
                                                <v-col cols="12" md="6">
                                                    <span class="font-weight-bold text-h6">REP Load Release</span>
                                                </v-col>
                                                <!-- <v-col class="text-right" cols="12" md="6">
                                                    <v-btn
                                                    @click="showAddRepDialog(user)"
                                                    prepend-icon="mdi-plus"
                                                    class="mt-1 rounded-lg"
                                                    color="routesColor"
                                                    height="40px"
                                                    elevation="2">
                                                        Add Rep Load
                                                    </v-btn>
                                                </v-col> -->
                                                <v-col cols="12" class="mt-1">
                                                    <v-card class="dt-container">    
                                                        <v-data-table
                                                            :mobile="isMobileOrTablet()"
                                                            :headers="repHeaders"
                                                            :items="repLoadData"
                                                            :loading="loading"
                                                            hide-default-footer
                                                            class="text-body-2"
                                                        >
                                                        <template v-slot:loading>
                                                            <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                                        </template>                                                <template v-slot:item.rep_title.title="{ item }">
                                                            <div style="max-width: 800px;">
                                                                <span >
                                                                    {{ item.rep_title.title }}
                                                                </span>

                                                                <span v-if="item.rep_title.category == 'Res'"> (Res)</span>
                                                                <span v-if="item.rep_title.category == 'Ext'"> (Ext)</span>
                                                                <span v-if="item.rep_title.category == 'Prod'"> (Prod)</span>

                                                                <span>({{ item.role  }})</span>
                                                            </div>
                                                        </template>
                                                        <template v-slot:item.datecreated="{ item }">
                                                            <span>{{ formatDateTime(item.datecreated)}} </span>
                                                        </template>
                                                        <template v-slot:[`item.action`]="{ item }">
                                                            <div class="d-flex justify-end ga-2">
                                                                <v-btn @click="showEditRepLoadDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                                            </div>
                                                        </template>
                                                        </v-data-table>
                                                    </v-card>
                                                </v-col>   
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row dense class="mt-8">
                                        <v-col cols="12">
                                            <v-row align="center">
                                            <v-col cols="12" md="7" class="text-lg-right">
                                                <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD UNITS/WK:</v-label>
                                            </v-col>
                                            <v-col cols="12" md="2">
                                                <v-text-field
                                                    v-model="total_irepa_units"
                                                    readonly
                                                    color="darkGreen"
                                                    variant="underlined"
                                                    density="comfortable"
                                                    class="font-weight-bold"
                                                ></v-text-field>
                                            </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-row align="center">
                                                <v-col cols="12" md="7" class="text-lg-right">
                                                    <v-label>TOTAL IREPA (Instruction, Research, Extension, Production and Administrative) LOAD HOURS/WK:</v-label>
                                                </v-col>
                                                <v-col cols="12" md="2">
                                                    <v-text-field
                                                        v-model="total_irepa_hours"
                                                        readonly
                                                        color="darkGreen"
                                                        variant="underlined"
                                                        density="comfortable"
                                                        class="font-weight-bold"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-menu
                    v-if="action != 'add'"
                    v-model="openWorkloadRemarks"
                    location="bottom center"
                    offset-y
                >
                    <!-- FAB Button as Activator -->
                    <template #activator="{ props }">
                    <v-badge v-if="workloadRemarksData.length > 0" color="red-accent-3" :content="workloadRemarksData.length">
                        <v-btn
                            v-bind="props"
                            :color="openWorkloadRemarks ? '' : 'primary'"
                            variant="flat"
                            elevation="4"
                            icon
                        >
                            <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                        </v-btn>
                    </v-badge>
                    <v-btn
                        v-else
                        v-bind="props"
                        :color="openWorkloadRemarks ? '' : 'primary'"
                        variant="flat"
                        elevation="4"
                        icon
                    >
                        <v-icon>{{ openWorkloadRemarks ? 'mdi-close' : 'mdi-comment-text-outline' }}</v-icon>
                    </v-btn>
                    </template>

                    <!-- Remarks Card -->
                    <v-card
                    class="rounded-lg"
                    style="display: flex; flex-direction: column; width: 400px;"
                    >
                    <v-card-title
                        class="d-flex justify-space-between align-center"
                        style="background-color: #1a5b0f !important;"
                    >
                        <div>
                        <span class="font-weight-bold text-h6 text-white">Remarks</span>
                        </div>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                        <v-timeline side="end">
                        <v-card elevation="0" v-if="workloadRemarksData.length === 0" class="w-100">
                            <v-card-text>No remarks made yet</v-card-text>
                        </v-card>

                        <v-timeline-item
                            v-for="remarks in workloadRemarksData"
                            :key="remarks.id"
                            size="x-small"
                        >
                            <v-alert border="start">
                            <div class="font-weight-bold font-italic">
                                "{{ remarks.details }}"
                            </div>
                            <br>
                            <div class="text-caption">
                                {{ getItemTitle(remarks.user_details) }} -
                                {{ formatDateTime(remarks.datecreated) }}
                            </div>
                            <div
                                v-if="remarks.user_details.id == $store.state.user.id"
                                class="mt-3"
                            >
                                <v-btn
                                @click="showEditRemarks(remarks)"
                                variant="flat"
                                color="orange-darken-1"
                                >
                                Edit
                                </v-btn>
                            </div>
                            </v-alert>
                        </v-timeline-item>
                        </v-timeline>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-3" style="margin-top: auto;">
                        <v-spacer></v-spacer>
                        <v-btn
                        class="mr-1"
                        :loading="loading"
                        text="Add Remarks"
                        variant="elevated"
                        elevation="1"
                        color="darkGreen"
                        @click="showAddRemarks()"
                        ></v-btn>
                    </v-card-actions>
                    </v-card>
                </v-menu>

                <v-spacer></v-spacer>

                <v-btn
                    class="mr-1"
                    :disabled="loading"
                    text="Cancel"
                    variant="outlined"
                    elevation="1"
                    @click="closeDialog()"
                ></v-btn>

                <v-btn
                    v-if="workLoadData.approved_status == null"
                    class="mr-1"
                    :loading="loading"
                    variant="elevated"
                    elevation="1"
                    color="darkGreen"
                    @click="validateForm()"
                >
                    {{ workLoadData.prepared_status == null ? 'Prepare and Save' : 'Update and Save' }}
                </v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmPrepare" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to mark as prepared this workload ?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, some details may not be updated. Please review the workload information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmPrepare = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="updateWorkload()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmCourseDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want delete this course?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmCourseDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteCourse()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <FacultyLoadDialog ref="FacultyLoadDialog" @refresh="loadAllTotals()"/>
    <AdminLoadDialog ref="AdminLoadDialog" @refresh="loadAllTotals()"/>
    <RepLoadDialog ref="RepLoadDialog" @refresh="loadAllTotals()"/>
    <WorkloadRemarkDialog ref="WorkloadRemarkDialog" @refresh="loadWorkloadRemarks()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import FacultyLoadDialog from './Sub-Dialogs/FacultyLoadDialog.vue';
import AdminLoadDialog from './Sub-Dialogs/AdminLoadDialog.vue';
import RepLoadDialog from './Sub-Dialogs/RepLoadDialog.vue';
import WorkloadRemarkDialog from './Sub-Dialogs/WorkloadRemarkDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import { exportPreApprovalPDF } from '@/composables/pdf/pre-aprroved-workload';

export default defineComponent({
     emits: ["refresh"],
     components: {
        FacultyLoadDialog,
        AdminLoadDialog,
        RepLoadDialog, 
        WorkloadRemarkDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            itemToDelete: null,
            confirmCourseDelete: false,

            is_team_teach: false,
            team_teach: null,
            confirmPrepare: false,
            workLoadData: [],
            workloadDetails: [],
            tab: null,

            id: null,
            user_id: null,
            faculty_name: null,
            employment_status: null,
            designation: null,
            rank: null,
            institute: null,
            department: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            team_teach_name: null,
            team_teach_undergraduate: null,
            team_teach_graduate: null,
            team_teach_post_graduate: null,
            core_time: null,
            consultation_time: null,
            total_teaching_hours: null,
            total_preparation: null,
            ms_load_eqv: null,
            ms_total_student: null,
            ge_load_eqv: null,
            ge_total_student: null,
            profed_load_eqv: null,
            profed_total_student: null,
            gs_load_eqv: null,
            gs_total_student: null,
            total_irepa_units: null,
            total_irepa_hours: null,
            vpaa_staff_code: null,
            department_arr: [],
            semester_schoolyear_id: this.$store.state.semester_schoolyear.id,
            
            user: [],
            instituteId: null,
            facultyDataForTeamTeach: [],
            teamTeachData: [],
            courseLoadData: [],
            adminLoadData: [],
            repLoadData: [],
            workloadRemarksData: [],
            openWorkloadRemarks: false,

            headers: [
                { title: 'Course No.', align: 'start', sortable: true, key: 'code' },
                { title: 'Course Title', align: 'start', sortable: true, key: 'title' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'Time', align: 'start', sortable: true, key: 'time' },
                { title: 'Day', align: 'start', sortable: true, key: 'day' },
                { title: 'Room', align: 'start', sortable: true, key: 'room' },
                { title: 'Program/Section', align: 'start', sortable: true, key: 'section_code' },
                { title: 'Class Size', align: 'start', sortable: true, key: 'class_size' },
                { title: 'Hours Lec (a)', align: 'start', sortable: true, key: 'hours_lecture' },
                { title: 'Hours Lab', align: 'start', sortable: true, key: 'hours_lab' },
                { title: 'Actual Contact Teaching Hrs/Wk', align: 'start', sortable: true, key: 'actual_contact_teaching' },
                { title: '.75 Eqv (b)', align: 'start', sortable: true, key: 'eqv' },
                { title: 'Total Load Eqv', align: 'start', sortable: true, key: 'total_eqv' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            loadHeaders: [
                { title: 'Description', align: 'start', sortable: true, key: 'description' },
                { title: 'Hours', align: 'start', sortable: true, key: 'hours' },
                { title: 'Unit', align: 'start', sortable: true, key: 'unit' },
                { title: 'To Be Counted', align: 'start', sortable: true, key: 'to_be_counted' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            repHeaders: [
                { title: 'SO Number', align: 'start', sortable: true, key: 'rep_title.so_number' },
                { title: 'Description', align: 'start', sortable: true, key: 'rep_title.title' },
                { title: 'Hours', align: 'start', sortable: true, key: 'unit_loading' },
                { title: 'Unit', align: 'end', sortable: true, key: 'unit_loading' },
            ],
        }
     },
     methods: {
        initAdd(instituteId){
            this.dialog = true
            this.dialog_title = 'Faculty Workload'
            this.dialog_sub_title = 'Add new faculty workload'
            this.action = 'add'

            this.instituteId = instituteId
            this.initUsers()
        },
        async initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Faculty Workload'
            this.dialog_sub_title = 'Update faculty workload details'
            this.action = 'edit'

            this.id = data.id
            this.user = data.user
            this.user_id = data.user.id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.vpaa_staff_code = data.vpaa_staff_code

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            await this.loadWorkloadRemarks()
        },
        async initView(data, tab){
            this.dialog = true
            this.dialog_title = 'Prepare Faculty Workload'
            this.dialog_sub_title = 'Prepare faculty workload details'
            this.action = 'view'

            this.tab = tab
            this.workLoadData = data
            this.id = data.id
            this.user = data.user
            this.user_id = data.user.id
            this.faculty_name = data.faculty_name
            this.employment_status = data.employment_status
            this.designation = data.designation
            this.rank = data.rank
            this.institute = data.institute
            this.department = data.department
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.team_teach_name = data.team_teach_name
            this.team_teach_undergraduate = data.team_teach_undergraduate,
            this.team_teach_graduate = data.team_teach_graduate,
            this.team_teach_post_graduate = data.team_teach_post_graduate,
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time
            this.vpaa_staff_code = data.vpaa_staff_code
            this.department_arr = data.department_arr

            if(!this.team_teach_name){
                this.is_team_teach = false
            }
            else{
                this.is_team_teach = true
            }

            await this.loadCourseLoad()

            this.total_teaching_hours = data.total_teaching_hours
            this.total_preparation = data.total_preparation
            this.ms_load_eqv = data.ms_load_eqv
            this.ms_total_student = data.ms_total_student
            this.ge_load_eqv = data.ge_load_eqv
            this.ge_total_student = data.ge_total_student
            this.profed_load_eqv = data.profed_load_eqv
            this.profed_total_student = data.profed_total_student
            this.gs_load_eqv = data.gs_load_eqv
            this.gs_total_student = data.gs_total_student

            await this.loadReleaseLoad()

            this.total_irepa_units = data.total_irepa_units
            this.total_irepa_hours = data.total_irepa_hours

            await this.loadWorkloadRemarks()
            await this.getRelatedUserDetailsByWorkloadId(data.id)
        },
        async initUserForTeamTeach(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findAllFacultyByProgramForTeamTeach/' + this.$store.state.user.programId + '/' + this.user_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.facultyDataForTeamTeach = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async getRelatedUserDetailsByWorkloadId(faculty_workload_id){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload/getRelatedUserDetailsByWorkloadId/' + faculty_workload_id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.workloadDetails = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async toggleTeachApplicable(value) {
            if (value) {
                await this.initUserForTeamTeach();
            } else {
                this.teamTeachData = [];
                this.team_teach_name = null;
                this.team_teach_undergraduate = null;
                this.team_teach_graduate = null;
                this.team_teach_post_graduate = null;
            }
        },
        async teamTeachEducation(){
            this.team_teach_name = this.getItemTitle(this.teamTeachData)
            this.team_teach_undergraduate = this.teamTeachData?.undergraduate
            this.team_teach_graduate = this.teamTeachData?.graduate
            this.team_teach_post_graduate = this.teamTeachData?.post_graduate
        },
        async changeTeamTeach(){
            await this.initUserForTeamTeach();
            this.teamTeachData = []
            this.team_teach_name = null
            this.team_teach_undergraduate = null
            this.team_teach_graduate = null
            this.team_teach_post_graduate = null
        },
        async loadUserInfo(){
            if (!this.user) return;
            if(this.user.length == 0) return;

            this.loading = true

            this.user_id = this.user.id
            this.faculty_name = this.user.fname + ' ' + (this.user.mname ? this.user.mname[0] + '.' : '') + ' ' + this.user.lname;
            this.employment_status = this.user.employmentStatus.description
            this.designation = this.user.designation ? this.user.designation : 'None'
            this.rank = this.user.academicRank.description
            this.institute = this.user.office.abbrev
            this.department = this.user.program.abbrev
            this.undergraduate = this.user.undergraduate
            this.graduate = this.user.graduate
            this.post_graduate = this.user.post_graduate,
            this.core_time = this.user.core_time
            this.consultation_time = this.user.consultation_time
            this.semester_schoolyear_id = this.$store.state.semester_schoolyear.id,

            this.loadAllTotals()

        },
        async loadAllTotals(){

            this.loading = true
            await this.loadCourseLoad()

            const totals = this.calculateCourseTypeTotals(this.courseLoadData)
            this.total_teaching_hours = totals.total_teaching_hours
            this.ms_load_eqv = totals.ms_load_eqv
            this.ms_total_student = totals.ms_total_student
            this.ge_load_eqv = totals.ge_load_eqv
            this.ge_total_student = totals.ge_total_student
            this.profed_load_eqv = totals.profed_load_eqv
            this.profed_total_student = totals.profed_total_student
            this.gs_load_eqv = totals.gs_load_eqv
            this.gs_total_student = totals.gs_total_student

            await this.loadReleaseLoad()

            const totalIREPA = this.calculateIREPATotals(totals, this.adminLoadData, this.repLoadData)
            this.total_irepa_hours = totalIREPA.total_irepa_hours
            this.total_irepa_units = totalIREPA.total_irepa_units

            this.loading = false
        },
        async loadCourseLoad(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-load/findAllBySemesterAndSchoolyear/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.courseLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadReleaseLoad(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/admin-load/findAllLoadByUserAndSemester/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.adminLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/rep-unit-load/findAllLoadByUserAndSemester/' + this.user_id + '/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.repLoadData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async loadWorkloadRemarks(){
            const token = localStorage.getItem('aums-token')
            await axios.get(process.env.VUE_APP_SERVER_URL + '/faculty-workload-remarks/findAllRemarksByWorkloadId/' + this.workLoadData?.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.workloadRemarksData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        calculateCourseTypeTotals(data) {
            const totals = {
                ms_load_eqv: 0,
                ms_total_student: 0,
                ge_load_eqv: 0,
                ge_total_student: 0,
                profed_load_eqv: 0,
                profed_total_student: 0,
                gs_load_eqv: 0,
                gs_total_student: 0,
                total_teaching_hours: 0,
            };

            data.forEach(item => {
                totals.total_teaching_hours += item.actual_contact_teaching;
                switch (item.course_type) {
                    case "Major Subject":
                        totals.ms_load_eqv += item.total_eqv;
                        totals.ms_total_student += item.class_size;
                        break;
                    case "General Education":
                        totals.ge_load_eqv += item.total_eqv;
                        totals.ge_total_student += item.class_size;
                        break;
                    case "Professional Education":
                        totals.profed_load_eqv += item.total_eqv;
                        totals.profed_total_student += item.class_size;
                        break;
                    case "Graduate School":
                        totals.gs_load_eqv += item.total_eqv;
                        totals.gs_total_student += item.class_size;
                        break;
                }
            });
            return totals;
        },
        calculateIREPATotals(teachingData, adminData, repData) {
            const adminTotals = adminData.reduce((totals, item) => {
                if (item.to_be_counted) {
                    totals.total_irepa_hours += item.hours;
                    totals.total_irepa_units += item.unit;
                }
                return totals;
            }, { total_irepa_hours: 0, total_irepa_units: 0 });

            const repTotals = repData.reduce((totals, item) => {
                totals.total_irepa_hours += item.unit_loading;
                totals.total_irepa_units += item.unit_loading;
                return totals;
            }, { total_irepa_hours: 0, total_irepa_units: 0 });

            const combinedIREPA = {
                total_irepa_hours: adminTotals.total_irepa_hours + repTotals.total_irepa_hours,
                total_irepa_units: adminTotals.total_irepa_units + repTotals.total_irepa_units
            };

            return {
                total_irepa_hours: teachingData.total_teaching_hours + combinedIREPA.total_irepa_hours,
                total_irepa_units: (
                    teachingData.ms_load_eqv +
                    teachingData.ge_load_eqv +
                    teachingData.profed_load_eqv +
                    teachingData.gs_load_eqv +
                    combinedIREPA.total_irepa_units
                )
            };
        },
        getItemTitle(item) {
            return `${item?.fname ?? ''} ${item?.mname ? item?.mname[0] + '.' : ''} ${item?.lname ?? ''}${item?.suffix ? ' ' + item?.suffix : ''}`;
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.confirmPrepare = true
            }
        },
        updateWorkload(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let formData = {
                id: this.id,
                user_id: this.user_id,
                faculty_name: this.faculty_name,
                employment_status: this.employment_status,
                designation: this.designation,
                rank: this.rank,
                institute: this.institute,
                department: this.department,
                undergraduate: this.undergraduate,
                graduate: this.graduate,
                post_graduate: this.post_graduate,
                team_teach_name: this.team_teach_name,
                team_teach_undergraduate: this.team_teach_undergraduate,
                team_teach_graduate: this.team_teach_graduate,
                team_teach_post_graduate: this.team_teach_post_graduate,
                core_time: this.core_time,
                consultation_time: this.consultation_time,
                total_teaching_hours: this.total_teaching_hours,
                total_preparation: this.total_preparation,
                ms_load_eqv: this.ms_load_eqv,
                ms_total_student: this.ms_total_student,
                ge_load_eqv: this.ge_load_eqv,
                ge_total_student: this.ge_total_student,
                profed_load_eqv: this.profed_load_eqv,
                profed_total_student: this.profed_total_student,
                gs_load_eqv: this.gs_load_eqv,
                gs_total_student: this.gs_total_student,
                total_irepa_hours: this.total_irepa_hours,
                total_irepa_units: this.total_irepa_units,
                vpaa_staff_code: this.vpaa_staff_code,
                semester_schoolyear_id: this.semester_schoolyear_id,
                preparer_ids: [Number(this.$store.state.user.id)],
                department_arr: this.department_arr
            }

            const token = localStorage.getItem('aums-token')

            axios.patch(process.env.VUE_APP_SERVER_URL + '/faculty-workload/updateWithPrepared', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Faculty Workload successfully updated!')
                    this.confirmPrepare = false
                    this.closeDialog()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        deleteCourse(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.delete(process.env.VUE_APP_SERVER_URL + '/faculty-load/' + this.itemToDelete.id ,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    showSnackbar('Faculty Load successfully deleted!')
                    this.confirmCourseDelete = false
                    this.loadAllTotals()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddFacultyLoadDialog(){
            this.$refs.FacultyLoadDialog.initProgChairAdd(this.user_id, this.$store.state.user.program.id)
        },
        showFacultyLoadDialog(data){
            this.$refs.FacultyLoadDialog.initUpdate(data)
        },
        showAddAdminDialog(data){
            this.$refs.AdminLoadDialog.initAdd(data)
        },
        showEditAdminLoadDialog(data){
            this.$refs.AdminLoadDialog.initUpdate(data)
        },
        showAddRepDialog(data){
            this.$refs.RepLoadDialog.initAdd(data)
        },
        showEditRepLoadDialog(data){
            this.$refs.RepLoadDialog.initUpdate(data)
        },
        showDeleteCourseDialog(data){
            this.itemToDelete = data
            this.confirmCourseDelete = true
        },
        showAddRemarks(){
            this.$refs.WorkloadRemarkDialog.initAdd(this.workLoadData.id)
        },
        showEditRemarks(data){
            this.$refs.WorkloadRemarkDialog.initUpdate(data)
        },
        closeDialog(){
            this.user = []
            this.dialog = false
        },
        checkPDFAssignatories() {
            const { showSnackbar } = useSnackbar();
            const workload = this.workloadDetails;

            const missingPreparers = workload.preparers?.filter(p => !p.esign) || [];
            if (missingPreparers.length > 0) {
                const names = missingPreparers.map(p => `${p.fname} ${p.lname}`).join(', ');
                showSnackbar(`Cannot generate PDF \n Preparer(s): ${names} \n has no e-signature uploaded.`);
                return;
            }

            const missingRecommenders = workload.recommenders?.filter(r => !r.esign) || [];
            if (missingRecommenders.length > 0) {
                const names = missingRecommenders.map(r => `${r.fname} ${r.lname}`).join(', ');
                showSnackbar(`Cannot generate PDF \n Recommender(s): ${names} \n has no e-signature uploaded.`);
                return;
            }

            if (workload.pre_approver && !workload.pre_approver.esign) {
                showSnackbar(`Cannot generate PDF \n Pre-approver ${workload.pre_approver.fname} ${workload.pre_approver.lname} has no e-signature uploaded.`);
                return;
            }

            this.workLoadData.semester = this.$store.state.semester_schoolyear.semester;
            this.workLoadData.schoolyear = this.$store.state.semester_schoolyear.schoolyear;

            exportPreApprovalPDF(this.courseLoadData, this.adminLoadData, this.repLoadData, this.workLoadData, this.workloadDetails);
        },
        getRepCategory(category){
            if(category == 'Res'){
                return '(Res)'
            }
            else if(category == 'Ext'){
                return '(Ext)'
            }
            else if(category == 'Pro'){
                return '(Prod)'
            }
        },
        getRepRole(role){
            if(role == 'Member'){
                return '(Member)'
            }
            else if(role == 'Leader'){
                return '(Leader)'
            }
        },
        getBase64Image(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL('image/png')); // Convert to Base64
                };
                img.onerror = error => reject(error);
            });
        },
     },
})
</script>

<style scoped>

</style>